import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#fcfcfd',
      width: '100%',
      height: '100%',
      maxWidth: 640,
      maxHeight: 471,
      padding: theme.spacing(5),
      fontFamily: 'Roboto',
    },
    rootMobile: {
      width: '100%',
      background: '#fcfcfd',
      padding: 12,
    },
  }),
);
